import { required, url } from '@vuelidate/validators'

export const MicroserviceValidation = {
    name: { required },
    host: { required, url },
    scopes: { required },
}
